import type { ReadonlyDeep } from 'type-fest';
import { z } from 'zod';

export const NavigationServiceAttributesSchema = z
  .object({
    base: z.string().optional(),
    movement_sensor: z.string().optional(),
    obstacle_detectors: z
      .array(
        z
          .object({
            vision_service: z.string().optional(),
            camera: z.string().optional(),
          })
          .passthrough()
      )
      .optional(),
    map_type: z.enum(['none', 'GPS']).optional(),
    motion_service: z.string().optional(),
    plan_deviation_m: z.number().optional(),
    position_polling_frequency_hz: z.number().optional(),
    obstacle_polling_frequency_hz: z.number().optional(),
    degs_per_sec: z.number().optional(),
    meters_per_sec: z.number().optional(),
    store: z.string().optional(),
  })
  .passthrough();

export type NavigationServiceAttributes = ReadonlyDeep<
  z.infer<typeof NavigationServiceAttributesSchema>
>;
